import React from 'react';
import Dropzone from 'react-dropzone';
import LocalizedStrings from '../../localization/strings';

export default function fileField(props) {

    let {onChange, value, name} = props;
    return (
        <Dropzone onDrop={(filesToUpload) => {
            onChange(filesToUpload[0]);
        }} multiple={false} name={name}>

            {value
                ? value.name
                : <div>{LocalizedStrings.selectOrDropFile}</div>}
        </Dropzone>
    )

}



// WEBPACK FOOTER //
// ./src/js/components/form/file-field.js